import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import { deleteReq, useGet, usePatch, usePost } from "src/http-clients/clients";
import { getActiveStoreId } from "src/redux/selectors/app";

export const useCreateExpense = () => {
  const activeStore = useSelector(getActiveStoreId);
  return usePost(`/users/${activeStore}/expenses/create-expense`);
};

export const useGetExpenses = ({
  length,
  page,
  search,
}: {
  length: number;
  page: number;
  search?: string;
}) => {
  const activeStore = useSelector(getActiveStoreId);
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(`/users/${activeStore}/expenses/list${queryData}`);
  return data;
};

export const useGetExpenseData = (expenseId?: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return useGet(
    expenseId ? `/users/${activeStore}/expenses/${expenseId}` : null
  );
};

export const useUpdateExpense = (expenseId?: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return usePatch(
    expenseId ? `/users/${activeStore}/expenses/${expenseId}` : null
  );
};

export const useDeleteExpense = () => {
  const activeStore = useSelector(getActiveStoreId);
  const deleteData = useCallback(
    (expenseId: number) => {
      return deleteReq(`/users/${activeStore}/expenses/${expenseId}`);
    },
    [activeStore]
  );
  return useFetchAsync(deleteData);
};
